import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Button } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  & > .ant-form-item-label {
    padding-bottom: 4px;
    height: 24px;
    & > label {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
  }
  .ant-form-item-explain-error {
    font-size: 13px;
  }
`;

export const StyledLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 4px;
  margin-top: 8px;
`;

export const StyledButton = styled(Button)`
  margin-top: 8px;
`;

export const StyledColumn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  &&& {
    height: 14px;
    width: 15px;
    margin-right: 12px;
    opacity: 70%;
    cursor: pointer;
  }
`;

export const StyledTableContainer = styled.div`
  padding-top: ${({ index }) => (index > 0 ? '24px' : '0px')};
`;
